import React from 'react';
import { useQuery } from 'urql';

const PreviewContext = React.createContext(
  /** @type {object | undefined}*/ (undefined)
);

/** @param {{children: React.ReactNode; } & import('urql').UseQueryArgs} props */
export function PreviewDataProvider({ children, ...rest }) {
  const data = useQuery(rest);

  return (
    <PreviewContext.Provider value={data}>{children}</PreviewContext.Provider>
  );
}

/** @return {import('urql').UseQueryResponse} */
export default function usePreviewData() {
  const data = React.useContext(PreviewContext);
  if (data === undefined) {
    // If we didn't wrap the page in a PreviewProvider, the hook should still be usable with the same interface without breaking.
    // So we provide default values that make sense in a production environment.
    return [{ fetching: false, stale: false, data: null }, () => {}];
  }
  const [previewData, rest] = data;
  const site = previewData.data?.allSite?.[0];
  const draftSite = previewData.data?.allSite?.[1];
  return [
    { ...previewData, data: { ...previewData.data, site: draftSite || site } },
    rest,
  ];
}
